import { ofType, StateObservable } from 'redux-observable';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ActionManagerInstance } from '../../actions/manager';
import { SAVE_AND_CLOSE } from '../save-and-close/action-creator';
import * as StateManager from '../../store/state/state-manager';
import { performSave } from '../save-and-close';
import { publicConstants } from '../../constants';
import type { Action } from '../../store/state/state-manager';
import type { ActionWithPayload, PerformAndSaveActionPayload } from '../save-and-close/types';
import type { State } from '../../types';

import { subscribeExpressLocalActionSubmitEvent, unSubscribeExpressLocalActionSubmitEvent } from './events';

export const processCallBacks = (actionInPayload: Action['payload']) => {
  const { callbacks } = actionInPayload;
  if (callbacks?.submit) {
    const expressSubmitCallback = (submitResponse: any) => {
      callbacks.submit(submitResponse);
      unSubscribeExpressLocalActionSubmitEvent('expressLocalActionSubmit');
    };
    subscribeExpressLocalActionSubmitEvent(expressSubmitCallback, 'expressLocalActionSubmit');
  }
};

export const saveAssignment = (action$: Action) => {
  let actionMgrID = 0;
  let caseType;
  const actionsOut: any[] = [];
  const state$ = { value: StateManager.getStore()?.getState() } as StateObservable<State>;
  return of(action$).pipe(
    ofType(SAVE_AND_CLOSE),
    switchMap((action: ActionWithPayload<PerformAndSaveActionPayload>) => {
      const { isFormValid } = action.payload;
      ({ actionMgrID, caseType } = action.payload);

      if (!isFormValid) {
        const error = { type: publicConstants.SUBMISSION_FAILURE_TYPE.FORM_VALIDATION_ERROR };
        ActionManagerInstance.rejectActionByID(actionMgrID, true, error);
        return of([]);
      }

      const saveActionObject = { action, state$, actionMgrID, caseType, actionsOut };

      return performSave(saveActionObject, true);
    })
  );
};

export default {
  processCallBacks
};
